export default "__VITE_ASSET__DkmZTn_R__"